import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { KeyValueExtended } from '../../models/key-value-extended';
import { SMTUsersService } from '../../services/users-service';
import { AppStore, SnackbarErrorAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { AldenService } from '../../services/alden.service';
import { ProfileState } from '@alfresco/adf-extensions';

@Component({
  selector: 'smt-search-people-select',
  templateUrl: './search-people-select.component.html',
  styleUrls: ['./search-people-select.component.scss'],
  host: { class: 'smt-search-people-select' }
})
export class SearchPeopleSelectComponent implements OnInit {
  @Output() optionSelected = new EventEmitter<MatAutocompleteSelectedEvent>();
  @Output() optionChanged = new EventEmitter<void>();
  @Output() removedValue = new EventEmitter<void>();

  @Input() group: FormGroup<any>;
  @Input() controlName: string;
  @Input() excludeControlName: string;
  @Input() label: string;
  @Input() options: KeyValueExtended<any, string>[];
  @Input() disabled: boolean;
  @Input() multiple: boolean;
  @Input() canClean: boolean;
  @Input() showTooltip: boolean;
  @Input() useChips: boolean;
  @Input() notAddStringValidator: boolean
  @Input() optionCSS: string;
  @Input() notDefaultUser: boolean
  @Input() searchQuery!: (value: string) => Promise<any>;
  @Input() searchValidator!: (value: string) => boolean;

  loading: boolean;

  constructor(private usersService: SMTUsersService, private store: Store<AppStore>, private aldenService: AldenService) {
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;

    this.label ??= "ALDEN.LOGIN.AUDIT_DIALOG.TEXT_USER";
    this.searchQuery ??= this.searchUser.bind(this);

    if(this.disabled === undefined) {
      this.disabled = this.group?.disabled || this.group.controls[this.controlName]?.disabled ? true : this.disabled;
    }

    if(!this.notDefaultUser && !this.disabled) {
      const profileState: ProfileState = await this.aldenService.getProfileState();
      this.group.controls[this.controlName].setValue(profileState.id);
    }

    this.loading = false;
  }

  searchUser(searchValue: string) {
    return this.usersService.searchPeople(searchValue).then((response: any) => {
      response = response ?? [];
      if (response.list.entries.length == 0) {
        this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.NO_DATA'));
      }
      return response.list.entries.map((nodeEntry: any) => {
        return {
          key: nodeEntry.entry.id,
          value: nodeEntry.entry.id  + " - " + nodeEntry.entry.displayName
        }
      });
    });
  }

}
